import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW, JSON_KEY_CODE, TABLE_HEADER_CODE, JSON_KEY_STATUS,
   TABLE_HEADER_STATUS, ConvertStatus, TABLE_HEADER_DESCRIPTION, JSON_KEY_DESCRIPTION, TABLE_HEADER_EXCHANGE,
   JSON_KEY_EXCHANGE,
   DROPDOWN_LIST_NONE,
   AddItemToDropdown,
   ADD_EXCHANGE,
   UPDATE_ROW,
   DELETE_ROW,
   instrumentCodeColor,
   rowOpacityForStatus,
   statusTextColor} 
from '../../common/common';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import { Modal } from 'react-bootstrap';
import MarketsAdminForm from '../forms/markets_admin_form';
import { addMarket } from '../../redux/dropDownSlice';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

const Markets = () => {
   const dispatch = useDispatch();
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const [dropDownMarketsData, setDropDownMarketsData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const [dropDownExchangesData, setDropDownExchangesData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);
   
   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[MarketsTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[MarketsTable] Row Double Clicked:`, rowData);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log('results details: ', details.data, 'r_type:', details.data.r_type, ', Message:', details.data.message, ', message:', JSON.stringify(details.data.message));

      const modifiedRow = {
         ...details.data,
         id: details.data.code,
         status: ConvertStatus(details.data.status),      };

      switch (details.type) {
         case ADD_ROW:
            setLocalTableData(prev => {
               const exists = prev.some(row => row.id === modifiedRow.id);
               if (exists) {
                  console.log(`Duplicate message with id ${modifiedRow.id} ignored.`);
                  return prev;
               }
               return [...prev, modifiedRow];
            });

            dispatch(addMarket({ id: modifiedRow.code, name: modifiedRow.code })); // Add for drop down lists
            AddItemToDropdown(setDropDownMarketsData, { id: details.data.code, name: details.data.code });
            break;

         case UPDATE_ROW:
            setLocalTableData(prevData => prevData.map(row => row.id === modifiedRow.id ? modifiedRow : row));
            break;

         case DELETE_ROW:
            setLocalTableData(prevData => prevData.filter(row => row.id !== modifiedRow.id));
            break;

         case ADD_EXCHANGE:
            AddItemToDropdown(setDropDownExchangesData, { id: details.data.code, name: details.data.code });
            break;

         default:
            console.log('Unknown event type:', details.type);
            break;
      }
   }, [dispatch]);

   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);

   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID }, // don't show it but it is still there
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_EXCHANGE, accessor: JSON_KEY_EXCHANGE },
      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="MarketsTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />
            
         <Modal show={showForm} onHide={handleCloseForm}>
            <MarketsAdminForm rowData={selectedRow} onClose={handleCloseForm} marketOptions={dropDownMarketsData} exchangeOptions={dropDownExchangesData} />
         </Modal>
      </>
   );
};

export default Markets;
